import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import InputDate from 'components/molecules/InputDate'
import { getDateForWeb, getDateFromServerDate } from 'utils/date'
import { changeFinishedOrdersPeriod, fetchOrdersRequest, resetOrdersPage } from 'store/orders/orders.actions'
import { selectFinishedOrdersDateFrom, selectFinishedOrdersDateTo } from 'store/orders/orders.selectors'
import { usePaginationLocation } from 'components/molecules/PaginationBar/pagination-location-hook'

import { useOrderListFinishedPeriodLocation } from './order-list-finished-period-location-hook'
import { getDefaultFinishedOrdersPeriod, isValidFinishedPeriodDate, normalizeFinishedOrdersPeriod } from './order-list-finished-period.utils'

import classes from './style.module.css'

const toInputDateValue = (serverDate: string) => {
  if (!serverDate || !isValidFinishedPeriodDate(serverDate)) return ''

  const date = getDateFromServerDate(serverDate)

  return date ? getDateForWeb(date) || '' : ''
}

export const OrderListFinishedPeriodFilter: React.FC = () => {
  const dispatch = useDispatch()
  const dateFrom = useSelector(selectFinishedOrdersDateFrom)
  const dateTo = useSelector(selectFinishedOrdersDateTo)
  const periodLocation = useOrderListFinishedPeriodLocation()
  const paginationLocation = usePaginationLocation()

  const applyPeriod = useCallback(
    (nextDateFrom: string, nextDateTo: string) => {
      const defaults = getDefaultFinishedOrdersPeriod()
      const period = normalizeFinishedOrdersPeriod(nextDateFrom || dateFrom || defaults.dateFrom, nextDateTo || dateTo || defaults.dateTo)

      periodLocation.setPeriod(period.dateFrom, period.dateTo)
      paginationLocation.setPage(1)
      dispatch(changeFinishedOrdersPeriod(period))
      dispatch(resetOrdersPage())
      dispatch(fetchOrdersRequest({ period }))
    },
    [dateFrom, dateTo, dispatch, paginationLocation, periodLocation],
  )

  const onDateFromChange = useCallback(
    (value: string) => {
      if (!isValidFinishedPeriodDate(value)) return

      applyPeriod(value, dateTo)
    },
    [applyPeriod, dateTo],
  )

  const onDateToChange = useCallback(
    (value: string) => {
      if (!isValidFinishedPeriodDate(value)) return

      applyPeriod(dateFrom, value)
    },
    [applyPeriod, dateFrom],
  )

  return (
    <div className={classes.periodRow}>
      <div className={classes.dateField}>
        <InputDate id="OrderListFinishedDateFrom" value={toInputDateValue(dateFrom)} onChangeHandler={onDateFromChange} className="m-0" />
      </div>
      <span className={classes.separator}>—</span>
      <div className={classes.dateField}>
        <InputDate id="OrderListFinishedDateTo" value={toInputDateValue(dateTo)} onChangeHandler={onDateToChange} className="m-0" />
      </div>
    </div>
  )
}

export default OrderListFinishedPeriodFilter
